import { DEFAULT_HELMET } from "constants/constants"
import React, { ReactNode } from "react"
import { Helmet } from "react-helmet-async"

interface HelmetWrapperProps {
  title: string
  content?: string
  children: ReactNode
}

function HelmetWrapper({ title, content = "", children }: HelmetWrapperProps) {
  return (
    <div>
      <Helmet>
        <title>
          {DEFAULT_HELMET} - {title}
        </title>
        <meta name="description" content={content} />
      </Helmet>
      {children}
    </div>
  )
}

export default HelmetWrapper
